export default {"src":"/_next/static/media/affirm_logo.67eef9ef.svg","height":22,"width":52,"blurWidth":0,"blurHeight":0};